import { types } from './reducer';
import auth from './auth';

export function asyncMiddleware(http) {
  return ({ dispatch, getState }) => next => action => {
    let { promise, type } = action;

    if(!promise) {
      return next(action);
    }

    const promised = promise(http, dispatch, getState);

    const { REQUEST, SUCCESS, FAILURE } = types(type);

    if(!promised || !promised.then) {
      dispatch({ type: SUCCESS, result: promised })
      return promised;
    }

    dispatch({ type: REQUEST });

    return promised.then(result => {
      dispatch({ type: SUCCESS, result })
      return result;
    }).catch(error => {

      if(!error.response || error.response.status != 401) {
        console.error(error);
      }

      if(error.response) {
        dispatch({ type: FAILURE, error: error.response.data })
      // } else if(error.message) {
      //   dispatch({ type: FAILURE, error: error.message })
      } else {
        dispatch({ type: FAILURE, error: error })
      }

      throw error;
    });

  };
}



// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/asyncMiddleware.js